import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { api } from "@/lib/api";
import { AuthImage } from "@/components/AuthImage";

// The illustrated cover MiLu paints for a story, polled until the picture lands.
export const StoryCover = ({ storyId }) => {
  const [story, setStory] = useState(null);

  useEffect(() => {
    let stop = false;
    let polls = 0;
    const tick = async () => {
      try {
        const { data } = await api.get(`/stories/${storyId}`);
        if (stop) return;
        setStory(data);
        polls += 1;
        if (data.cover_status === "pending" && polls < 30) setTimeout(tick, 6000);
      } catch (err) {
        console.error("Story cover poll failed:", err);
      }
    };
    tick();
    return () => {
      stop = true;
    };
  }, [storyId]);

  if (!story) return null;

  return (
    <div className="mt-3 flex justify-start" data-testid={`story-cover-card-${storyId}`}>
      <div className="max-w-[85%] overflow-hidden rounded-3xl border border-white/10 bg-panel">
        {story.cover_creation_id ? (
          <AuthImage
            creationId={story.cover_creation_id}
            alt={story.title}
            className="aspect-[16/9] w-full object-cover"
            testid={`story-inline-cover-${storyId}`}
          />
        ) : (
          <p className="flex items-center gap-2 p-4 text-xs text-ink-soft">
            <Loader2 className="h-4 w-4 animate-spin text-brand" /> Illustrating the cover…
          </p>
        )}
        <div className="flex items-center gap-3 p-4">
          <span dir="auto" className="min-w-0 flex-1 truncate font-display text-sm font-bold tracking-tight">
            {story.title}
          </span>
          <Link
            to={`/stories/${storyId}`}
            data-testid={`story-open-${storyId}`}
            className="shrink-0 rounded-full bg-brand/15 px-4 py-2 text-xs text-brand hover:bg-brand/25"
          >
            Open in Library
          </Link>
        </div>
      </div>
    </div>
  );
};
